export default [
  {
    title: '素材ID',
    key: 'imageId',
    width: 60,
    fixed: 'left'
  },
  {
    title: '素材名称',
    key: 'imageName',
    width: 150,
    fixed: 'left',
    overflow: true
  },
  {
    title: '设计师',
    key: 'designerName',
    width: 80,
    fixed: 'left'
  },
  {
    title: '素材标签',
    key: 'labelNames',
    width: 120,
    overflow: true
  },
  {
    title: '来源',
    key: 'source',
    width: 60,
    overflow: true
  },
  {
    title: '营销主题标签',
    key: 'typeLabelNames',
    width: 100,
    overflow: true
  },
  {
    title: '上传时间',
    key: 'uploadTime',
    width: 140
  },
  {
    title: '合计消耗',
    key: 'amount',
    width: 86,
    align: 'right'
  },
  {
    title: '统计天数',
    key: 'countDayNum',
    width: 82,
    align: 'right'
  },
  {
    title: '安卓合计消耗',
    key: 'amountAndroid',
    width: 96,
    align: 'right'
  },
  {
    title: '安卓成本',
    key: 'createRoleCostAndroid',
    width: 74,
    align: 'right'
  },
  {
    title: '安卓充值',
    key: 'newRoleMoneyAndroid',
    width: 74,
    align: 'right'
  },
  {
    title: '安卓新创角回款率',
    key: 'newRoleRateAndroid',
    width: 117,
    align: 'right'
  },
  {
    title: '安卓回款计算器参考值',
    key: 'payBackCalcValueAndroid',
    width: 146,
    align: 'right'
  },
  {
    title: '安卓回款判断',
    key: 'payBackCalcStandardAndroid',
    width: 95,
    align: 'right'
  },
  {
    title: '安卓付费人数',
    key: 'payRoleUserNumAndroid',
    width: 95,
    align: 'right'
  },
  {
    title: 'iOS合计消耗',
    key: 'amountIOS',
    width: 92,
    align: 'right'
  },
  {
    title: 'iOS成本',
    key: 'createRoleCostIOS',
    width: 80,
    align: 'right'
  },
  {
    title: 'iOS充值',
    key: 'newRoleMoneyIOS',
    width: 80,
    align: 'right'
  },
  {
    title: 'iOS新创角回款率',
    key: 'newRoleRateIOS',
    width: 117,
    align: 'right'
  },
  {
    title: 'iOS回款计算器参考值',
    key: 'payBackCalcValueIOS',
    width: 140,
    align: 'right'
  },
  {
    title: 'iOS回款判断',
    key: 'payBackCalcStandardIOS',
    width: 92,
    align: 'right'
  },
  {
    title: 'iOS付费人数',
    key: 'payRoleUserNumIOS',
    width: 92,
    align: 'right'
  }
]
